export const intialAmendment = {
    "amendment_id": null,
    "amedment_date": null,
    "amendment_notes":null,
}